import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Platforms } from "@/components/site/Platforms";
import { Fleet } from "@/components/site/Fleet";
import { Testimonials } from "@/components/site/Testimonials";
import { Booking } from "@/components/site/Booking";
import { Manifesto } from "@/components/site/Manifesto";
import { Features } from "@/components/site/Features";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="bg-white" data-testid="landing-page">
        <Header />
        <main>
          <Hero />
          <Platforms />
          <Fleet />
          <Testimonials />
          <Booking />
          <Manifesto />
          <Features />
          <FAQ />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
